import React from 'react';
import Button from 'components/Button';

import Modal from 'antd/lib/modal/Modal';
import DF from 'DisplayFramework';
import MarketingCompaign, { McInputProps } from './Marketing';
import { ParMarketingResponse } from 'services/assetconfig';
import GetLabel from 'DisplayFramework/components/GetLabel';

type MarketingListModalProps = Pick<
  McInputProps,
  'initialSearchParams' | 'onSelect'
> & {
  onCancel?: () => void;
  visible?: boolean;
  onSelect: (mcomp: ParMarketingResponse) => void;
};

const MarketingListModal = ({
  visible,
  onCancel,
  onSelect,
}: MarketingListModalProps) => {
  return (
    <DF.Provider pagcode="mcList">
      <Modal
        visible={visible}
        onCancel={onCancel}
        width={1300}
        title={<GetLabel label='marketingcampaignmodal'/>}
        footer={[<Button key="cancel" comcode="cancel" onClick={onCancel} />]}
      >
        <MarketingCompaign
          onSelect={onSelect}
          initialSearchParams={{ mcstatus: 'ACTIVE' }}
        />
      </Modal>
    </DF.Provider>
  );
};

export default MarketingListModal;
